import { Day } from '@/entities/day';
import { getDayOfWeekShortName } from '@/shared/lib/utils/dates';

export const getDayTitle = (day: Day) => {
    const dateObj = new Date(day.publishedAt);
    const short = getDayOfWeekShortName(dateObj);
    const date = dateObj.getDate();
    return `${short}, ${date}`;
};
